"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMintl = require("@godaddy/react-mintl");
var _table = _interopRequireWildcard(require("@ux/table"));
var _okFilled = _interopRequireDefault(require("@ux/icon/ok-filled"));
var _delete = _interopRequireDefault(require("@ux/icon/delete"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _collapsible = _interopRequireDefault(require("@ux/collapsible"));
var _LearnMore = require("./styles/LearnMore");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LearnMore = ({
  heading,
  rowContent,
  columnContent,
  isModal = false,
  handleModalClose = () => {}
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const renderRowBody = rowBody => {
    const value = rowBody?.value;
    const icon = value ? /*#__PURE__*/_react.default.createElement(_okFilled.default, {
      "data-cy": "ok-icon",
      className: "ok-icon-style",
      height: 40,
      width: 40
    }) : /*#__PURE__*/_react.default.createElement(_delete.default, {
      "data-cy": "delete-icon",
      height: 40,
      width: 40
    });
    return rowBody?.isIcon ? icon : formatMessage({
      id: value
    });
  };
  const renderRowHeader = rowHeader => {
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null, rowHeader.showIcon && /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
      height: 18,
      width: 18
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)({
        'pl-2': rowHeader.showIcon
      })
    }, formatMessage({
      id: rowHeader.title
    })));
  };
  const LearnMoreContent = () => {
    return /*#__PURE__*/_react.default.createElement(_LearnMore.LearnMoreWrap, null, heading && /*#__PURE__*/_react.default.createElement("h4", {
      "data-cy": "learn-more-heading",
      "data-testid": "learn-more-heading",
      className: "learn-more-heading"
    }, formatMessage({
      id: heading
    })), /*#__PURE__*/_react.default.createElement(_table.default, {
      "data-cy": "learn-more-table",
      "data-testid": "learn-more-table",
      className: "learn-more-table",
      density: "sm"
    }, /*#__PURE__*/_react.default.createElement(_table.Thead, null, /*#__PURE__*/_react.default.createElement(_table.Tr, null, columnContent.map(column => /*#__PURE__*/_react.default.createElement(_table.Th, {
      "data-cy": "column-header",
      "data-testid": "column-header",
      className: "column-header",
      key: `th-${column}`
    }, formatMessage({
      id: column
    }))))), /*#__PURE__*/_react.default.createElement(_table.Tbody, null, rowContent.map((row, index) => /*#__PURE__*/_react.default.createElement(_table.Tr, {
      key: `tr-${row?.rowHeader?.title}`
    }, /*#__PURE__*/_react.default.createElement(_table.Th, {
      "data-cy": "row-header",
      "data-testid": "row-header",
      className: `row-header-${index}`
    }, /*#__PURE__*/_react.default.createElement(_collapsible.default, {
      id: `row-header-${index}`,
      title: renderRowHeader(row.rowHeader),
      className: "learn-more-collapsible"
    }, /*#__PURE__*/_react.default.createElement("p", null, formatMessage({
      id: row.rowHeaderDescription
    })))), row.rowBody.map((body, rowBodyIndex) => /*#__PURE__*/_react.default.createElement(_table.Td, {
      "data-cy": "row-body",
      className: "row-body",
      key: rowBodyIndex
    }, renderRowBody(body))))))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isModal ? /*#__PURE__*/_react.default.createElement(_LearnMore.LearnMoreModalWrap, {
    id: "learnMoreModal",
    "data-cy": "learn-more-modal",
    "data-testid": "learn-more-modal",
    onClose: handleModalClose
  }, /*#__PURE__*/_react.default.createElement(LearnMoreContent, null)) : /*#__PURE__*/_react.default.createElement(LearnMoreContent, null));
};
LearnMore.propTypes = {
  heading: _propTypes.default.string,
  rowContent: _propTypes.default.arrayOf(_propTypes.default.shape({
    rowHeader: _propTypes.default.shape({
      title: _propTypes.default.string,
      showIcon: _propTypes.default.bool
    }),
    rowHeaderDescription: _propTypes.default.string,
    rowBody: _propTypes.default.arrayOf(_propTypes.default.shape({
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
      isIcon: _propTypes.default.bool
    }))
  })).isRequired,
  columnContent: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  isModal: _propTypes.default.bool,
  handleModalClose: _propTypes.default.func
};
var _default = exports.default = LearnMore;